export { createEffect } from './effects/utils/create-effect.ts';
export {
  createCheckboxEffect,
  type CheckboxEffectDeps
} from './effects/checkbox/create-checkbox-effect.ts';
export { createApplyFillEffect } from './effects/fill/create-apply-fill-effect.ts';
export {
  createClearCellsEffect,
  type ClearCellsEffectDeps
} from './effects/clear/create-clear-cells-effect.ts';
export { createHighlightsEffect } from './effects/highlights/create-highlights-effect.ts';
export { createFillHandleEffect } from './effects/highlights/create-fill-handle-effect.ts';
export { createFocusBoxEffect } from './effects/highlights/create-focus-box-effect.ts';
export { createFillPreviewEffect } from './effects/highlights/create-fill-preview-effect.ts';
export {
  FIXED_HIGHLIGHTS_SURFACE_Z_INDEX,
  getTableBaseFragmentZIndex
} from './effects/highlights/constants.ts';
export { createPresenceEffect } from './effects/presence/create-presence-effect.ts';
export { createDeleteIntentHighlightEffect } from './effects/highlights/create-delete-intent-highlight-effect.ts';
export { initializeSelectionsMachine } from './initialize-selections-machine.ts';
export { SelectionsMachine } from './machine/selection-machine.ts';
export { hasActiveEdit } from './machine/utils/has-active-edit.ts';
export { type SelectionReducerPolicies } from './machine/reducers/types.ts';
export type { SelectionsMachineConstructorOptions } from './machine/selection-machine.ts';
export { createProjectionChangesInput } from './inputs/projection-changes/projection-changes-input.ts';
export {
  createMouseInput,
  type CreateMouseInputOptions,
  type MouseRowViewportBounds
} from './inputs/mouse-input/create-mouse-input.ts';
export {
  type MouseHitTarget,
  type MouseInputAdapter
} from './inputs/mouse-input/mouse-input-adapter.ts';
export type {
  SelectionUiInteraction,
  SelectionUiModifiers
} from './inputs/selection-ui-interaction.ts';
export {
  createKeyboardInputFor,
  type KeyboardInputHandler
} from './inputs/keyboard-input/create-keyboard-input-for.ts';
export { isEditableTarget } from './inputs/keyboard-input/utils/is-editable-target.ts';
export { createTableCellActionsInput } from './inputs/keyboard-input/table-cell-actions/create-table-cell-actions-input.ts';
export { createTableTabNavigationInput } from './inputs/keyboard-input/table-tab-navigation/create-table-tab-navigation-input.ts';
export { createTableNavigationInput } from './inputs/keyboard-input/table-navigation/create-table-navigation-input.ts';
export { type TableNavigationAdapter } from './inputs/keyboard-input/table-navigation-adapter.ts';
export { createContextMenuInput } from './inputs/context-menu-input/create-context-menu-input.ts';
export {
  createSelectionsPingEffect,
  type SelectionsPingEffectDeps
} from './effects/ping/create-selections-ping-effect.ts';
export { createColumnSelectionPingEffect } from './effects/ping/create-column-selection-ping-effect.ts';
export { createRowSelectionHandlePingEffect } from './effects/ping/create-row-selection-handle-ping-effect.ts';

// types
export { type PresenceEffectDeps } from './effects/presence/types.ts';

export { type SelectionEffectFactory } from './effects/types.ts';
export { type SelectionInputFactory } from './inputs/types.ts';
export { type SharedEventLoop } from './inputs/event-loop.ts';

export {
  type GridPosition,
  type RowSelectionFlattened,
  type RowSelectionSegment,
  type SelectionMode,
  type SelectionRange
} from './machine/state/types.ts';
export { type SelectionInput } from './inputs/types.ts';
export { type SelectionDeltaMap } from './machine/deltas/types.ts';
export { type SelectionState } from './machine/state/types.ts';
